import React, { useEffect, useState } from "react";

const CounterPopup = ({ media, onSave, onClose }) => {

    const [name, setName] = useState("");
    const [startValue, setStartValue] = useState(0);
    const [endValue, setEndValue] = useState(100);
    const [step, setStep] = useState(1);
    const [direction, setDirection] = useState("Up");
    const [duration, setDuration] = useState(10);
    const [prefix, setPrefix] = useState("");
    const [suffix, setSuffix] = useState("");

    useEffect(() => {

        if (media) {
            setName(media.name);
            setStartValue(media.startValue || 0);
            setEndValue(media.endValue || 100);
            setStep(media.step || 1);
            setDirection(media.direction || "Up");
            setDuration(media.duration || 10);
            setPrefix(media.prefix || "");
            setSuffix(media.suffix || "");
        }

    }, [media]);

    const handleSave = () => {

        onSave({
            id: media?.id || null,
            name,
            startValue,
            endValue,
            step,
            direction,
            duration,
            prefix,
            suffix
        });

    };

    return (

        <div className="popup-overlay">
            <div className="popup-content" style={{ width: 600 }}>

                <h2>{media ? "Edit Counter" : "Add Counter"}</h2>

                <div className="form-group">
                    <label>Name</label>
                    <input
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Start Value</label>
                    <input
                        type="number"
                        className="form-control"
                        value={startValue}
                        onChange={(e) => setStartValue(Number(e.target.value))}
                    />
                </div>

                <div className="form-group">
                    <label>End Value</label>
                    <input
                        type="number"
                        className="form-control"
                        value={endValue}
                        onChange={(e) => setEndValue(Number(e.target.value))}
                    />
                </div>

                <div className="form-group">
                    <label>Step</label>
                    <input
                        type="number"
                        className="form-control"
                        value={step}
                        onChange={(e) => setStep(Number(e.target.value))}
                    />
                </div>

                <div className="form-group">
                    <label>Direction</label>
                    <select
                        className="form-control"
                        value={direction}
                        onChange={(e) => setDirection(e.target.value)}
                    >
                        <option value="Up">Count Up</option>
                        <option value="Down">Count Down</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Prefix</label>
                    <input
                        className="form-control"
                        placeholder="₹, $, Visitors:"
                        value={prefix}
                        onChange={(e) => setPrefix(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Suffix</label>
                    <input
                        className="form-control"
                        placeholder="+, %, Units"
                        value={suffix}
                        onChange={(e) => setSuffix(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Duration (seconds)</label>
                    <input
                        type="number"
                        className="form-control"
                        value={duration}
                        onChange={(e) => setDuration(Number(e.target.value))}
                    />
                </div>

                <div className="form-buttons">
                    <button className="btn btn-success" onClick={handleSave}>
                        Save
                    </button>

                    &nbsp;

                    <button className="btn btn-primary" onClick={onClose}>
                        Cancel
                    </button>
                </div>

            </div>
        </div>
    );
};

export default CounterPopup;